import { useState } from "react";
import { Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { AuthLink, AuthShell } from "@/components/account/AuthShell";
import { Field, FormError, PasswordField, SubmitButton } from "@/components/account/Field";
import { useAccount } from "@/context/AccountContext";
import { errorMessage } from "@/lib/api";

const safeNext = (next) => (next && next.startsWith("/") && !next.startsWith("//") ? next : "/account");

export default function AccountLogin() {
  const { customer, login } = useAccount();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: params.get("email") || "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const next = safeNext(params.get("next"));

  if (customer) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await login(form.email, form.password);
      navigate(next, { replace: true });
    } catch (err) {
      setError(errorMessage(err, "Accesso non riuscito. Riprova."));
      setLoading(false);
    }
  };

  return (
    <AuthShell testid="account-login-page" lines={["Bentornato", "nella crew."]} kicker="sfushop · il tuo account">
      <form onSubmit={submit} className="space-y-6" data-testid="account-login-form">
        <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-smoke">Accedi per vedere ordini e spedizioni</p>
        <Field label="Email" required type="email" autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="account-login-email-input" />
        <PasswordField label="Password" required autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="account-login-password-input" />
        <div className="text-right text-sm">
          <AuthLink to="/account/password-dimenticata" testid="account-forgot-link">Password dimenticata?</AuthLink>
        </div>
        <FormError error={error} testid="account-login-error" />
        <SubmitButton loading={loading} testid="account-login-submit-button" loadingText="Accesso…">Accedi</SubmitButton>
        <p className="border-t border-line pt-6 text-sm text-bone/70">
          Non hai ancora un account? <AuthLink to="/account/registrati" testid="account-go-register-link">Registrati</AuthLink>
        </p>
      </form>
    </AuthShell>
  );
}
